module.exports = __webpack_public_path__ + "img/member-demo.256277e8.jpeg";